import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TextField,
} from "@mui/material";
import { Close as CloseIcon, ContentCopy as ContentCopyIcon } from "@mui/icons-material";

const GetLinksModal = ({ open, onClose, links }) => {
  const [copiedStates, setCopiedStates] = useState({});
  const [allCopied, setAllCopied] = useState(false);

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedStates((prev) => ({ ...prev, [id]: true }));
    setTimeout(() => {
      setCopiedStates((prev) => ({ ...prev, [id]: false }));
    }, 2000);
  };

  const handleCopyAll = () => {
    const allLinks = links.map((link) => link.link).join("\n");
    navigator.clipboard.writeText(allLinks);
    setAllCopied(true);
    setTimeout(() => {
      setAllCopied(false);
      onClose();
    }, 2000);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Generated Links
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <List>
          {links.map((link, index) => (
            <ListItem
              key={index}
              secondaryAction={
                <Button
                  variant="contained"
                  onClick={() => handleCopy(link.link, index)}
                  startIcon={<ContentCopyIcon />}
                >
                  {copiedStates[index] ? "Copied!" : "Copy"}
                </Button>
              }
            >
              <ListItemText primary={link.title} secondary={link.link} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={handleCopyAll} variant="contained" color="primary">
          {allCopied ? "Copied!" : "Copy All"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GetLinksModal;
